<template>
  <div class="frameWrap">
    <iframe
      v-if="user && formParam"
      id="JotFormIFrame-202858671363462"
      title="Associate Coach & Independent Contractor Agreement
      for Associate Coaches of Global Coach Group"
      onload="window.parent.scrollTo(0,0);"
      allowtransparency="true"
      allowfullscreen="true"
      allow="geolocation; microphone; camera"
      :src="`https://form.jotform.com/202858671363462?${formParam.join('&')}`"
      frameborder="0"
      style="width: 100%; min-height: 800px; border:none;"
      scrolling="yes"
    >
    </iframe>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'FormTwo',

  computed: {
    ...mapState({
      user: (state) => state.account.user,
    }),

    formParam() {
      let list = [];
      if (this.$route.query) {
        const params = this.$route.query;
        list = Object.keys(params).map((key) => `${key}=${params[key]}`);
      }
      return list;
    },
  },

  mounted() {
    if (this.user && this.user.certifications) {
      const flag = this.user.certifications.find((el) => el.certification.id === 'indiv_coaching');
      if (!flag) {
        this.redirectToDashboard('certification');
      }
    } else {
      this.redirectToDashboard();
    }

    if (!this.user?.services) { this.redirectToDashboard(); }
  },

  methods: {
    redirectToDashboard(message) {
      if (message === 'certification') {
        this.$toast.warning('The Associate Coach Program is for certified coaches only');
        this.$router.push({ name: 'dashboard' });
      } else if (message === 'gcg') {
        // this.$toast.warning('You already participate in GCG Platform.');
        window.open(process.env.VUE_APP_GCG_PLATFORM_CLIENT, '_self');
      } else {
        this.$router.push({ name: 'dashboard' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .frameWrap {
    width: 100%;
    overflow: auto;
  }
</style>
